import React, { useEffect, useState } from 'react';
import signin from '../../assets/signin.png';
import logo from '../../assets/logo.svg';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import apiRequest from '../../utils/apiRequest';
import { useDispatch, useSelector } from 'react-redux';
import { authSuccessful } from '../../store/userSlice';
import { RootState } from '../../store';

const Login = () => {
  const [formData, setFormData] = useState<{
    email?: string;
    password?: string;
  }>({
    email: '',
    password: '',
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userToken = useSelector((state: RootState) => state.user.token);

  const handleSubmit = async (e: React.MouseEvent<HTMLElement>) => {
    if (!formData.email || !formData.password) {
      toast.error('Please fill all fields');
      return;
    }

    const reqBody = {
      username: formData.email,
      password: formData.password,
    };

    const res = await apiRequest('signIn', reqBody);

    if (!res?.data?.token) {
      toast.error('Failed to login');
    } else {
      toast.success('Login successful');
      const { token, email } = res.data;

      console.log('signin success: ', res.data);

      dispatch(
        authSuccessful({
          email,
          token,
        })
      );
      navigate('/');
    }
  };

  const handleForm = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
  };

  useEffect(() => {
    if (userToken) {
      navigate('/');
    }
  }, []);

  return (
    <div className='flex w-full min-h-screen flex-wrap'>
      <div className='w-full h-screen md:w-[50%] '>
        <div className='border flex items-center justify-center min-h-screen'>
          <div className='w-[300px] md:w-[450px] p-10'>
            <div className='flex items-center justify-center'>
              <img src={logo} alt='deyga logo' className='h-[75px]' />
            </div>
            <div className='text-[30px] text-center font-semibold my-5'>
              Login
            </div>
            <div>
              <div className='flex flex-col'>
                <label className='font-semibold text-[13px]'>
                  Email address
                </label>
                <input
                  type='text'
                  placeholder='Email'
                  className='w-full mt-2 border p-2 rounded-md bg-[#F8FAFC]'
                  name='email'
                  value={formData?.email}
                  onChange={handleForm}
                />
              </div>

              <div className='flex flex-col my-3'>
                <label className='font-semibold text-[13px]'>Password</label>
                <input
                  type='password'
                  placeholder='password'
                  className='w-full mt-2 border p-2 rounded-md bg-[#F8FAFC]'
                  name='password'
                  value={formData?.password}
                  onChange={handleForm}
                />
              </div>
            </div>
            <div className='flex justify-between items-center'>
              <button
                className='w-[130px] bg-[#482B14] text-white p-2 rounded-md text-[14px] font-semibold'
                onClick={handleSubmit}
              >
                Login
              </button>

              <div className='text-center mt-3'>
                <Link
                  to={''}
                  className='text-[#2563EB] cursor-pointer text-[15px] font-medium'
                >
                  Forgot password?
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='w-full h-full md:w-[50%] hidden md:block'>
        <img src={signin} className='w-full h-screen object-cover' />
      </div>
    </div>
  );
};

export default Login;
